module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-signature-pad",
    class: 'signature-pad-' + _vm.field.name,
    attrs: {
      "id": _vm.field.name + 'a'
    },
    on: {
      "!click": function($event) {
        return _vm.onMouseOver.apply(null, arguments)
      },
      "!mouseover": function($event) {
        return _vm.onMouseOver.apply(null, arguments)
      }
    }
  }, [_c('div', {
    ref: "signatureRef",
    staticClass: "m-signature-pad--body"
  }, [(_vm.locked) ? _c('img', {
    staticClass: "signature-image",
    attrs: {
      "src": _vm.value,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.locked) ? _c('canvas', {
    ref: "signatureCanvasRef",
    attrs: {
      "id": _vm.field.name + '-canvas'
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.required && !_vm.field.hide
      }),
      expression: "{required: required && !field.hide}"
    }],
    attrs: {
      "type": "hidden",
      "data-vv-name": _vm.field.name,
      "data-vv-as": _vm.field.description.replace(/\./g, '')
    },
    domProps: {
      "value": _vm.signatureData
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-signature-pad--footer"
  }, [_c('div', {
    staticClass: "description"
  }), _vm._v(" "), _c('button', {
    staticClass: "button clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSignature
    }
  }, [_vm._v("\n      Clear\n    ")]), _vm._v(" "), (_vm.showClearMessage) ? _c('span', {
    staticClass: "clear-message"
  }, [_vm._v("\n      Please clear previous signature before creating new one.\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd4a5088","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/SignatureRender.vue
// module id = 1745
// module chunks = 1